import { useMemo, useState } from "react";
import { characters } from "@/mocks/loveHelperData";

const roleFilters = [
  { key: "all", label: "全部角色" },
  { key: "女主", label: "女主" },
  { key: "男主", label: "男主" },
  { key: "配角", label: "配角" },
];

export default function CharacterSection() {
  const [active, setActive] = useState("all");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    let list = characters;
    if (active !== "all") {
      const isMain = active === "女主" || active === "男主";
      list = list.filter((c) => {
        if (active === "女主") return c.role === "女主" || c.role.includes("女主");
        if (active === "男主") return c.role === "男主" || c.role.includes("男主");
        if (active === "配角") return !c.role.includes("女主") && !c.role.includes("男主");
        return true;
      });
    }
    if (keyword.trim()) {
      const kw = keyword.trim();
      list = list.filter(
        (c) =>
          c.name.includes(kw) ||
          c.role.includes(kw) ||
          c.tags.some((t) => t.includes(kw))
      );
    }
    return list;
  }, [active, keyword]);

  return (
    <section id="characters" className="mx-auto max-w-7xl px-4 py-16 md:py-20 md:px-6">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div>
          <span className="text-sm font-semibold text-primary-600">角色图鉴</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
            恋爱辅助器漫画人物介绍
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            男主女主、竹马白月光与助攻闺蜜逐一登场，附人物关系与关键标签，帮你快速认识每一位主要角色。
          </p>
        </div>
      </div>

      <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap gap-2">
          {roleFilters.map((f) => (
            <button
              key={f.key}
              type="button"
              onClick={() => setActive(f.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === f.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="relative w-full sm:w-64">
          <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索角色或标签…"
            className="w-full rounded-full border border-background-300 bg-background-50 py-2.5 pl-10 pr-4 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((c) => (
          <article
            key={c.id}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="relative h-72 w-full overflow-hidden bg-background-200">
              <img
                src={c.image}
                alt={`${c.name} - ${c.role}，${c.personality}`}
                title={`${c.name} 恋爱辅助器漫画角色`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
                {c.role}
              </span>
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-foreground-900">{c.name}</h3>
                <span className="text-sm text-foreground-500">{c.age} · {c.personality}</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{c.intro}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="mt-12 flex flex-col items-center py-10 text-center">
          <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
          <p className="mt-3 text-sm text-foreground-500">没有找到匹配的角色，换个关键词试试吧。</p>
        </div>
      )}
    </section>
  );
}